






































































import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import { Icon } from '@superbet-group/web.lib.ui-components';
import EventCardLabel from './EventCardLabel.vue';
import EventPin from './EventPin.vue';
import { TvChannel } from '@sportOfferFederation/tvChannels/types';
import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';
import SdsTooltipPortal from '@shared/components/tooltip/SdsTooltipPortal.vue';

export default defineComponent({
    name: 'EventMediaSection',
    emits: ['pinClick'],
    props: {
        expandedEvent: {
            type: Number,
            default: null,
        },
        liveVideo: {
            type: Boolean,
            default: false,
        },
        broadcast: {
            type: Array as PropType<TvChannel[]>,
            default: null,
        },
        news: {
            type: Boolean,
            default: false,
        },
        code: {
            type: [Number, String],
            required: false,
            default: '',
        },
        isCodeShown: {
            type: Boolean,
            default: true,
        },
        isPinShown: {
            type: Boolean,
            default: false,
        },
        isEventPinned: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        isMobileLayout() {
            return isMobileLayout();
        },
    },
    components: {
        EventCardLabel,
        EventPin,
        Icon,
        SdsTooltipPortal,
    },
});
